import React, { useContext } from 'react';
import ApplicationContext    from 'contexts/application/context';

export const useApplication = () => {
  return useContext(ApplicationContext);
};
